module.exports = __webpack_public_path__ + "static/media/ic_session_scheduled_popup_Failed.cc68bb61.svg";